import { categoryApi } from "../../api";
import { Link } from "react-router-dom";
import React, {useEffect, useState} from "react";

export default function Category({ onLoaded }) {

    const [categories, setCategories] = useState([]);


    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const { data } = await categoryApi.getCategories();
                setCategories(data.categories || []);
                onLoaded?.();
            } catch (err) {

            } finally {

            }
        };

        fetchCategories();
    }, []);



    return (
        <section className="flat-spacing-2 pt-0">
            <div className="container">
                <div className="flat-wrap-cls tf-grid-layout tf-col-2 xl-col-3">
                    {categories.map((category) => (
                        <div
                            className="wg-cls style-abs2 style-lg hover-img"
                            key={category.slug}
                        >
                            <Link to={`/product-list?category=${category.slug}`} className="image-wrap relative">
                            <div className="image img-style">
                                    <img
                                        src={category.image}
                                        data-=""
                                        alt=""
                                        className="lazyload"
                                        width={696}
                                        height={696}
                                    />
                                </div>
                                <div className="cls-btn text-center">
                                    <button className="tf-btn btn-white hover-dark">
                                        View all
                                    </button>
                                </div>
                                <span className="tf-overlay" />
                            </Link>
                            <div className="cls-content text-center">
                                <Link
                                    to={`/product-list?category=${category.slug}`}
                                    className="text-type text-xl-2 fw-medium link"
                                >
                                    {category.name}
                                </Link>
                                {/*<span className="count-item body-text-2 text-main">*/}
                                {/*  {category.items}*/}
                                {/*</span>*/}
                            </div>
                        </div>
                    ))}
                     {/*Pagination */}
                </div>
            </div>
        </section>
    );
}
